import { createFragmentDefinition } from "core/utils";
import { fragment } from "./fragment";
export { fragment } from "./fragment";
export var fragmentDefinition = createFragmentDefinition(fragment, "ProgramOverviewFragment");
